<template>
  <div id="app">
    <TopNavigation />
    <section class="section">
      <div class="container">
        <router-view/>
      </div>
    </section>
    <vue-snotify/>
  </div>
</template>

<script defer src="https://use.fontawesome.com/releases/v5.0.7/js/all.js"></script>
<script>
import TopNavigation from '@/components/TopNavigation.vue'
export default {
  name: 'app',
  components: {
    'TopNavigation': TopNavigation
  }
}
</script>

<style>
@import '../node_modules/bulma/css/bulma.css';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
